import React, { useContext } from "react";
import { AppContext } from "../../../../appContext";
import { ISideMenuRouteProps } from "./ISideMenuRouteProps";
import { PopupWrapper } from "../../../../components/styled/BasicBlocks";
import { SideMenuCommonHeader } from "./SideMenuCommon";
import "./SideMenuHelp.css";

export const SideMenuHelp = ({ onClose }: ISideMenuRouteProps) => {
    const { translate } = useContext(AppContext);
    return <PopupWrapper className="SideMenuHelp">
        <SideMenuCommonHeader text={translate('sideMenu_help')} onClose={onClose}>
        </SideMenuCommonHeader>
    </PopupWrapper>
}